import { ISubmissionRepository } from "domain/contracts/submission.contract";
import { Message } from "domain/entities/message";
import { Submission } from "domain/entities/submission";
import { FormSubmissionInputFilter } from "domain/models/nimberforms-input-filters";
import { httpClient } from "infra/axios/axios-api";

class SubmissionRepository implements ISubmissionRepository{
    async create(submission: Submission): Promise<Message<Submission>> {
        const createdSubmission = await httpClient.post("/submission", {data: submission});
        return createdSubmission.data;
    }

    async getByFilter(filter: FormSubmissionInputFilter): Promise<Message<Submission[]>> {
        const submissions = await httpClient.get("/submission", {params: filter});
        return submissions.data;
    }

}

export default new SubmissionRepository();
